module.exports = __webpack_public_path__ + "static/img/glasses_04.d1dd54a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/accessories/thumbnail/glasses_04.png
// module id = izlL
// module chunks = 0